import { Component, OnInit } from '@angular/core';
import { Piece } from '../../../inventory/piece';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { SalesService } from '../../../sales/sales.service';
import { TdDialogService } from '@covalent/core/dialogs/services/dialog.service';
import { PoService } from '../../../purchasing/pos/po.service';
import { PoBranch } from '../../../purchasing/pos/poBranch';
import { AuthenticationService } from '../../../../shared/services/authentication.service';
import { LocationService } from 'services/location.service';
import { Location } from '../../../accounting/location';
import { InlineCutComponent } from '../../../../shared/dialogs/inline-cut/inline-cut.component';
import { MdDialogRef } from '@angular/material';
import { InventoryService } from '../../../inventory/inventory.service';
import { SelectSimilarPieceComponent } from '../../../../shared/dialogs/select-similar-piece/select-similar-piece.component';
import { NewPreparedPieceComponent } from '../../../../shared/dialogs/new-prepared-piece/new-prepared-piece.component';
import { Product } from 'app/agatextscreens/purchasing/products/product';
import { ProductService } from '../../../purchasing/products/product.service';
import { PrintingService } from '../../../../shared/services/printing.service';

@Component({
  selector: 'app-prepare-order-items',
  templateUrl: './prepare-order-items.component.html',
  styleUrls: ['./prepare-order-items.component.scss'],
  providers: [ProductService, PrintingService]
})
export class PrepareOrderItemsComponent implements OnInit {
  id: string;
  order_number: string = '';
  order_items: Piece[] = [];
  grouped_items: { location: string, pieces: Piece[] }[] = [];

  items_not_prepared: Piece[] = [];

  branchLocations: Location[];
  _branch_id: number;

  _scanned: string = '';
  _location: string = '';

  multiMode: boolean = false;

  _notes: string = '';
  _customerId: number = 0;

  constructor(private _salesService: SalesService,
    private _poService: PoService,
    private _dialogService: TdDialogService,
    private _locationService: LocationService,
    private router: Router,
    private route: ActivatedRoute,
    public _authService: AuthenticationService,
    private _productService: ProductService,
    private _printService: PrintingService,
    private _inventoryService: InventoryService
  ) { }

  ngOnInit() {
    this.route.params.subscribe(
      params => {
        this.id = params['id'];
        this._salesService.getSaleItems(this.id + '').subscribe(
          response => {
            this.order_items = response;
            // Check what's already checked
            this.order_items.forEach(
              item => {
                if (item['prepared_location_id'] != null && item['prepared_location_id'] != 0) {
                  item['checked'] = true;
                } else {
                  //NB: since to javascript, '' == 0, we need to force the location_id back to undefined
                  delete item['prepared_location_id'];
                }
              }
            );
            this.groupByLocation();
          }
        );

        this._salesService.getOneSale(this.id).subscribe(
          saleOrder => {
            this._notes = saleOrder.notes;
            this._customerId = saleOrder.customer_id;
          }
        )
      }
    );

    this.route.queryParams.subscribe(
      params => {
        this.order_number = params['order_number'];
        this._branch_id = params['branch_id'];

        this._locationService.getLocations(params['branch_id']).subscribe(
          response => {
            this.branchLocations = response;
          }
        );
      }
    );
  }

  preparedStatusText() {
    let totalPieces: number = this.order_items.length;
    let preparedPieces: number = this.order_items.filter(p => { return p.prepared_location_id }).length;
    let totalMeters: number = this.order_items.reduce((a, b) => { return a + b.quantity }, 0);
    let preparedMeters: number = this.order_items.filter(p => { return p.prepared_location_id }).reduce((a, b) => { return a + b.quantity }, 0);

    return preparedPieces + '/' + totalPieces + ' pieces prepared, ' + parseFloat(preparedMeters.toString()).toFixed(2) + '/' + parseFloat(totalMeters.toString()).toFixed(2) + ' meters prepared';
  }

  preparedStatusValue() {
    let totalPieces: number = this.order_items.length;
    let preparedPieces: number = this.order_items.filter(p => { return p.prepared_location_id }).length;

    return (preparedPieces / totalPieces) * 100;
  }

  unPrepareItem(item) {
    this._dialogService.openPrompt(
      {
        title: 'New Location',
        message: 'You are "unpreparing" this roll. Please provide the rack location where it will be left'
      }
    ).afterClosed().subscribe(
      response => {
        if (response) {
          let _newLocation = this.branchLocations.find((l: Location) => { return l.name == response });

          if (_newLocation) {
            // Move the piece back and if it worked, uncheck the piece
            this._inventoryService.changeLocation(item.piece_number, response, this._branch_id).subscribe(
              result => {
                if (result.status == 'SUCCESS') {
                  item.checked = false;
                  item.prepared_location_id = null;

                  item.location = response;

                  this.grouped_items = [];
                  this.groupByLocation();

                  this.savePreparationStatus(true);
                } else {
                  item.checked = false;
                  item.prepared_location_id = null;

                  this._dialogService.openAlert(
                    {
                      title: 'WARNING',
                      message: 'Could not set the new location. Please set it manually using the "Change location" PDA functionality'
                    }
                  );

                  this.savePreparationStatus(true);
                }
              },
              error => {
                item.checked = false;
                item.prepared_location_id = null;

                this._dialogService.openAlert(
                  {
                    title: 'WARNING',
                    message: 'Could not set the new location. Please set it manually using the "Change location" PDA functionality'
                  }
                );

                this.savePreparationStatus(true);
              }
            );
          } else {
            this._dialogService.openPrompt(
              {
                title: 'Wrong location',
                message: 'The provided location does not exist or is not in this branch'
              }
            )
          }
        }
      }
    );
    console.log(item)
  }

  groupByLocation() {
    console.log(this.order_items);

    this.order_items.forEach(
      item => {
        let this_group = this.grouped_items.find(i => { return item['location'] == i['location'] });

        if (this_group != null) {
          this_group.pieces.push(item);
        } else {
          this.grouped_items.push({ location: item['location'], pieces: [item] })
        }
      }
    );
    // Order alphabetically
    this.grouped_items.sort((a, b) => { return (a.location > b.location) ? 1 : -1 })
  }

  swapPiece(item: Piece) {
    let _dRef: MdDialogRef<SelectSimilarPieceComponent> = this._dialogService.open(SelectSimilarPieceComponent);

    // Get branch code from my list of branches
    _dRef.componentInstance.branch_code = this._authService.getUserBranches().find(b => { return b.id == this._branch_id }).code;
    _dRef.componentInstance.alsoInList = this.order_items;
    _dRef.componentInstance.pieceNumber = item.piece_number;

    _dRef.afterClosed().subscribe(
      (newPiece: Piece) => {
        if (newPiece) {

          /*
          // When replacing, figure out whether to update the length or not

          // If we needed to cut it before:
          if (item.quantity * 1 < item.full_length * 1) {
            // And now the roll is smaller, we forego the cutting
            if (item.quantity >= newPiece.length) {
              item.quantity = newPiece.length;
            }
          } 
          */

          // If the newly selected roll is smaller than the requested qty change 
          // the requested qty to the new roll length
          if (item.quantity * 1 > newPiece.length * 1) {
            item.quantity = newPiece.length;
          }

          // Replace the key values in the item
          item.id = newPiece.id;
          item.full_length = newPiece.length;
          item['location'] = newPiece.location_name;
          item.piece_number = newPiece.piece_number;
          item.sold = newPiece.sold;
          item.deleted = newPiece.deleted;

          console.log(item, newPiece);
        }
      }
    );

  }

  overrideItemCut(item: Piece) {
    item.quantity = item.full_length;
  }

  printAllFreeTextLabels() {
    this.grouped_items.forEach(
      group => {
        group.pieces.forEach(
          piece => {
            this.printFreeTextLabel(piece)
          }
        );
      }
    );
  }

  printFreeTextLabel(itemToPrint: Piece) {
    let piece: Piece;

    console.log('Attempting to print tag for: ' + itemToPrint.id);

    this._inventoryService.getPiece(itemToPrint.id, false).subscribe(
      (response: Piece[]) => {
        if (Array.isArray(response) && response.length > 0) {
          piece = response[0];

          // Fill in the gaps from the product view

          this._productService.getOneProduct(piece.color_id + '').subscribe(
            (product: Product) => {
              if (product != null) {
                this._printService.print(
                  {
                    company_ft: itemToPrint.tag,
                    collection: piece.collection_name,
                    design: piece.design_name,
                    color: piece.color_name,
                    piece_number: piece.piece_number,
                  }, this._authService.getPrinterId(), 1, 'freetext').subscribe(
                    response => {
                      if (response['status'] == 'SUCCESS') {
                        this._dialogService.openAlert({
                          message: 'Sent to print queue!',
                          title: 'Success'
                        });
                      } else {
                        this._dialogService.openAlert({
                          message: 'Could not send to print queue!',
                          title: 'Failed'
                        });
                      }
                    }
                  );
              } else {
                this._dialogService.openAlert({
                  message: 'The product information could not be retrieved!',
                  title: 'Failed'
                });
              }
            }
          );
        } else {
          this._dialogService.openAlert({
            message: 'The roll information could not be found!',
            title: 'Failed'
          });
        }
      }
    );
  }

  markScanned(_scanned: string): void {
    console.log(_scanned);

    if (_scanned == null && _scanned == '') {
      return;
    }

    if (!location) {
      this._dialogService.openAlert({
        title: 'Invalid Location',
        message: 'The scanned location is not a valid location in the Order\'s sourcing branch'
      });
      return;
    }

    _scanned.split(/\s+/).forEach(
      _scannedPiece => {
        this.order_items.forEach(
          (i) => {
            if (i.piece_number == _scannedPiece) {

              if (i.sold || i.deleted) {
                this._dialogService.openAlert({ title: 'Warning', message: 'The piece ' + i.piece_number + ' is no longer available. Please swap it for another piece.' });

              } else if (i.quantity * 1 < i.full_length * 1) {
                this._dialogService.openAlert({ title: 'Warning', message: 'Please cut the roll ' + i.piece_number + ' before scanning' });

              } else {
                let _loc = this.getFullLocation();

                console.log(_loc);
                if (_loc) {
                  i['checked'] = true;
                  i['prepared_location_id'] = _loc.id;
                  i['prepared_location_name'] = _loc.name;
                } else {
                  this._dialogService.openAlert({
                    title: 'Invalid Location',
                    message: 'The scanned location is not a valid location in the Order\'s sourcing branch'
                  });
                  return;
                }
              }
            }
          }
        );
      }
    );
    this._scanned = '';
  }

  allItemsChecked() {
    return (this.order_items.length - this.order_items.reduce((a, b) => { return a + (b['checked'] ? 1 : 0) }, 0)) == 0
  }

  getFullLocation(): Location {
    return (this.branchLocations.find((l: Location) => { return l.name == this._location }));
  }

  allCutsClear(): boolean {
    let clear: boolean = true;

    this.order_items.forEach(
      (item: Piece) => {
        console.log(item.quantity * 1, item.full_length * 1, item.quantity * 1 < item.full_length * 1)
        if (item.quantity * 1 < item.full_length * 1) {
          clear = false;
        }
      }
    );

    return clear;
  }

  openInlineCut(item: Piece) {
    let _d: MdDialogRef<InlineCutComponent> = this._dialogService.open(InlineCutComponent);

    _d.componentInstance.pieceNumber = item.piece_number;
    _d.componentInstance.fullLength = item.full_length;
    _d.componentInstance.newLength = item.full_length - item.quantity;

    _d.afterClosed().subscribe(
      result => {
        // Disregard undefined: they clicked outside
        if (result != null) {
          // Capture OK and NOK
          if (result) {
            item.full_length = item.quantity;
          } else {
            this._dialogService.openAlert(
              {
                title: 'Problem',
                message: 'Could not cut the piece in two'
              }
            )
          }
        }

        /*this._salesService.getSaleItems(this.id + '').subscribe(
          response => {
            this.order_items = response;
          }
        );*/
      }
    );
  }

  savePreparationStatus(stayAfter?: boolean) {
    this._salesService.getOneSale(this.id).subscribe(
      salesOrder => {
        // Set the order as preparing and set the location
        salesOrder.status = 'PREPARING';
        // Add the items back to the order
        salesOrder.items = this.order_items;

        this._salesService.updateSale(salesOrder.id, salesOrder).subscribe(
          response => {
            if (response['status'] == 'SUCCESS') {
              // Also update the B2B PO in case it needs so
              if (!salesOrder.customer_id || salesOrder.customer_id == 0) {
                this._poService.getBranchPoByNumber(this.order_number).subscribe(
                  (response: PoBranch) => {
                    if (response != null && response.id != null) {
                      // Update the PO items
                      response.transferItems = this.order_items;
                      // Call the "ID" "Piece_ID" and 
                      response.transferItems.forEach(p => { p.piece_id = p.id; p.length = p.length ? p.length : p.quantity });
                      // Then update
                      this._poService.updateBranchPo(response.po_id, response).subscribe(
                        updateResponse => {
                          if (updateResponse['status'] == 'SUCCESS') {
                            console.log('Updated PO')
                          } else {
                            console.log('Could not update PO')
                          }
                        },
                        error => {
                          console.log('Could not update PO')
                        }
                      );
                    }
                  }
                );
              }

              this._dialogService.openAlert({
                title: 'Success!',
                message: 'Saved successfully'
              }).afterClosed().subscribe(
                result => {
                  if (!stayAfter) this.router.navigate(['/pda', 'shipping', 'prepareOrder']);
                }
              );
            } else {
              this._dialogService.openAlert({
                title: 'Failed!',
                message: 'Could not save order status'
              });
            }
          }
        );

        // Also update the pieces' locations
        this.order_items.forEach(
          item => {
            if (item['checked']) {
              this._inventoryService.changeLocation(item['piece_number'], item['prepared_location_name'], this._branch_id).subscribe(
                response => {

                }
              );
            }
          }
        );
      }
    );
  }

  prepareOrder() {
    let doAnyways: boolean = false;
    let location: Location = this.getFullLocation();

    /*if (!location) {
      this._dialogService.openAlert({
        title: 'Invalid Location',
        message: 'The scanned location is not a valid location in the Order\'s sourcing branch'
      });
      return;
    }*/

    console.log(this.allCutsClear());

    if (!this.allCutsClear()) {
      this._dialogService.openAlert({
        title: 'Missing cuts',
        message: 'Some pieces have not been cut yet to fulfill this order. Cut all items marked as cut pending and try again'
      });
      return;
    }

    if (!this.allItemsChecked()) {
      this._dialogService.openConfirm({
        title: 'Verify the information',
        message: 'Not all pieces have been scanned. Do you want to mark as prepared anyways?',
        acceptButton: 'Yes',
        cancelButton: 'No'
      }).afterClosed().subscribe(
        result => {
          // Yes --> true
          // No --> false
          // Click outside --> Undefined
          if (result) {
            let _items: Piece[] = Object.assign([], this.order_items);
            // Remove all items that were not checked
            this.order_items = _items.filter(oi => { return oi['checked'] });
            // And keep the items that were not checked for later
            this.items_not_prepared = _items.filter(oi => { return !oi['checked'] });

            this.doPrepareOrder();
          }
        }
      );
    } else {
      this.doPrepareOrder();
    }

  }

  doPrepareOrder() {
    // Mark the sales order as "PREPARED"
    this._salesService.getOneSale(this.id).subscribe(
      salesOrder => {
        // Set the order as prepared and set the location
        salesOrder.status = 'PREPARED';
        //response.prepared_location_id = location.id;
        // Add the items back to the order
        salesOrder.items = this.order_items;

        console.log(salesOrder);

        this._salesService.updateSale(salesOrder.id, salesOrder).subscribe(
          response => {
            if (response['status'] == 'SUCCESS') {
              // Here we save the items that were not prepared
              this._salesService.setItemsNotPrepared(salesOrder.id, this.items_not_prepared).subscribe(
                response => {

                },
                error => {

                }
              );

              // Also update the B2B PO in case it needs so
              if (!salesOrder.customer_id || salesOrder.customer_id == 0) {
                this._poService.getBranchPoByNumber(this.order_number).subscribe(
                  (response: PoBranch) => {
                    if (response != null && response.id != null) {
                      // Update the PO items
                      response.transferItems = this.order_items;
                      let notPreparedItems = this.items_not_prepared;

                      // Call the "ID" "Piece_ID" and 
                      response.transferItems.forEach(p => { p.piece_id = p.id; p.length = p.length ? p.length : p.quantity });
                      notPreparedItems.forEach(p => { p.piece_id = p.id; p.length = p.length ? p.length : p.quantity });

                      // Then update
                      this._poService.updateBranchPo(response.po_id, response).subscribe(
                        updateResponse => {
                          if (updateResponse['status'] == 'SUCCESS') {
                            console.log('Updated PO')
                          } else {
                            console.log('Could not update PO')
                          }
                        },
                        error => {
                          console.log('Could not update PO')
                        }
                      );

                      this._poService.setBranchPoNotPreparedItems(response.po_id, notPreparedItems).subscribe(
                        updateResponse => {
                          if (updateResponse['status'] == 'SUCCESS') {
                            console.log('Updated PO')
                          } else {
                            console.log('Could not update PO')
                          }
                        },
                        error => {
                          console.log('Could not update PO')
                        }
                      );
                    }
                  }
                );
              }

              this._dialogService.openAlert({
                title: 'Success!',
                message: 'Order prepared successfully'
              }).afterClosed().subscribe(
                result => {
                  this.router.navigate(['/pda', 'shipping', 'prepareOrder']);
                }
              );
            } else {
              this._dialogService.openAlert({
                title: 'Failed!',
                message: 'Could not prepare order'
              });
            }
          }
        );
      }
    );

    // Also update the pieces' locations
    this.order_items.forEach(
      item => {
        if (item['checked']) {
          this._inventoryService.changeLocation(item['piece_number'], item['prepared_location_name'], this._branch_id).subscribe(
            response => {

            }
          );
        }
      }
    );

    // If this was Branch to branch PO, Mark the Purchase order as "PREPARED"
    this._poService.getBranchPoByNumber(this.order_number).subscribe(
      (response: PoBranch) => {
        if (response != null && response.id != null) {
          response.status = 'PREPARED';
          this._poService.updateBranchPo(response.po_id, response).subscribe(
            response => {

            },
            error => {

            }
          );
        }
      }
    );
  }

  addPiece() {
    let _dlg: MdDialogRef<NewPreparedPieceComponent> = this._dialogService.open(NewPreparedPieceComponent);
    _dlg.componentInstance.customer_id = this._customerId;
    _dlg.componentInstance.order_items = this.order_items;

    _dlg.afterClosed().subscribe(
      piece => {
        if (piece) {
          this._inventoryService.getPiece(piece.id, false).subscribe(
            p => {
              if (Array.isArray(p) && p.length > 0) {
                this.order_items.push(Object.assign(p[0], piece, { location: p[0].location_name, quantity: p[0].length }));

                this.grouped_items = [];
                this.groupByLocation();
              }
            }
          );
        }
      }
    );
  }

} 



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/pda/shipping/prepare-order-items/prepare-order-items.component.ts